export default __webpack_public_path__ + "static/community-b99743349785abbd327f199ee91e0099.png";